import styled from 'styled-components';

export const UserGuideStyle = styled.div`
  .userGuideInner {
    background: #0b0f1b;
    height: calc(-70px + 100vh);

    .userGuideHead {
      padding: 32px 40px 24px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.06);
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      gap: 20px;

      .headContent {
        flex: 1;
        min-width: 280px;
      }

      .userGuideTitle {
        font-family: Poppins;
        font-size: 28px;
        font-weight: 700;
        letter-spacing: -0.02em;
        text-align: left;
        color: white;
        margin-bottom: 6px;
        line-height: 1.2;
        text-transform: uppercase;
      }

      .userGuideSubtitle {
        font-family: Poppins;
        font-size: 14px;
        font-weight: 400;
        color: #b8b8b8;
        line-height: 1.5;
      }

      .searchWrapper {
        position: relative;
        width: 100%;
        max-width: 280px;
      }

      .searchLabel {
        padding: 10px 14px;
        background: rgba(255, 255, 255, 0.05);
        display: flex;
        align-items: center;
        width: 100%;
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 8px;
        transition: all 0.2s ease;
        cursor: text;

        &:focus-within {
          border-color: #007aff;
          background: rgba(255, 255, 255, 0.08);
        }

        .searchIconDiv {
          margin-right: 10px;
          display: flex;
          align-items: center;
          color: #b8b8b8;
          font-size: 14px;
          flex-shrink: 0;
        }

        input {
          background: transparent;
          border: none;
          font-family: Poppins;
          font-weight: 400;
          line-height: 20px;
          text-align: left;
          width: 100%;
          color: white;
          outline: none;
          font-size: 13px;

          &::placeholder {
            color: rgba(255, 255, 255, 0.4);
          }
        }

        .dropdownIcon {
          color: rgba(255, 255, 255, 0.4);
          flex-shrink: 0;
          margin-left: 8px;
          transition: transform 0.2s ease;
        }
      }

      .suggestionsDropdown {
        position: absolute;
        top: calc(100% + 6px);
        left: 0;
        right: 0;
        background: #1a1f2e;
        border: 1px solid rgba(255, 255, 255, 0.12);
        border-radius: 8px;
        max-height: 320px;
        overflow-y: auto;
        z-index: 100;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
        list-style: none;
        padding: 6px;
        margin: 0;

        /* Custom scrollbar */
        &::-webkit-scrollbar {
          width: 6px;
        }
        &::-webkit-scrollbar-track {
          background: transparent;
        }
        &::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.15);
          border-radius: 3px;
        }
        &::-webkit-scrollbar-thumb:hover {
          background: rgba(255, 255, 255, 0.25);
        }

        .suggestionItem {
          padding: 10px 12px;
          font-family: Poppins;
          font-size: 13px;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.8);
          cursor: pointer;
          border-radius: 6px;
          transition: all 0.15s ease;

          &:hover {
            background: rgba(0, 122, 255, 0.15);
            color: #ffffff;
          }
        }
      }
    }

    .userGuideContent {
      display: grid;
      grid-template-columns: 240px 1fr;
      min-height: calc(100vh - 100px);

      @media (max-width: 1024px) {
        grid-template-columns: 1fr;
      }
    }

    /* Table of Contents Sidebar - Fixed */
    .tableOfContents {
      position: sticky;
      top: 0;
      height: calc(100vh - 100px);
      overflow-y: auto;
      background: rgba(255, 255, 255, 0.02);
      border-right: 1px solid rgba(255, 255, 255, 0.06);
      padding: 24px 16px;

      /* Custom scrollbar for TOC */
      &::-webkit-scrollbar {
        width: 3px;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      &::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.1);
        border-radius: 3px;
      }

      @media (max-width: 1024px) {
        position: relative;
        height: auto;
        border-right: none;
        border-bottom: 1px solid rgba(255, 255, 255, 0.06);
        padding: 20px;
      }

      .tocTitle {
        font-family: Poppins;
        font-size: 11px;
        font-weight: 600;
        color: rgba(255, 255, 255, 0.5);
        text-transform: uppercase;
        letter-spacing: 0.1em;
        margin-bottom: 16px;
        padding-left: 12px;
      }

      .tocList {
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        flex-direction: column;
        gap: 2px;

        @media (max-width: 1024px) {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
          gap: 4px;
        }
      }

      .tocItem {
        a {
          display: flex;
          align-items: center;
          padding: 8px 12px;
          font-family: Poppins;
          font-size: 12px;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.6);
          text-decoration: none;
          border-radius: 6px;
          transition: all 0.15s ease;
          border-left: 2px solid transparent;

          &:hover {
            color: #ffffff;
            background: rgba(255, 255, 255, 0.05);
          }

          &.active {
            color: #007aff;
            background: rgba(0, 122, 255, 0.1);
            border-left-color: #007aff;
            font-weight: 500;
          }
        }

        .tocNumber {
          color: #007aff;
          font-weight: 600;
          margin-right: 8px;
          font-size: 11px;
          min-width: 20px;
        }
      }
    }

    /* Main Content Area */
    .mainContent {
      min-width: 0;
      padding: 32px 40px 80px;
      overflow-y: auto;
      max-height: calc(100vh - 100px);

      @media (max-width: 1024px) {
        max-height: none;
        padding: 24px 20px 60px;
      }
    }

    /* Intro Section */
    .introSection {
      margin-bottom: 32px;
      padding: 28px;
      background: rgba(255, 255, 255, 0.03);
      border: 1px solid rgba(255, 255, 255, 0.08);
      border-radius: 10px;

      .introTitle {
        font-family: Poppins;
        font-size: 18px;
        font-weight: 600;
        line-height: 1.4;
        color: white;
        margin-bottom: 16px;
      }

      .contentParagraph {
        color: #b8b8b8;
        font-family: Poppins;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.7;
        margin-bottom: 12px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    /* Platform Guide Section */
    .platformGuideSection {
      margin-bottom: 32px;

      .sectionTitle {
        font-family: Poppins;
        font-size: 20px;
        font-weight: 600;
        line-height: 1.3;
        color: white;
        margin-bottom: 8px;
      }

      .subsectionTitle {
        font-family: Poppins;
        font-size: 14px;
        font-weight: 500;
        color: #007aff;
        margin-bottom: 12px;
      }

      .contentParagraph {
        color: #b8b8b8;
        font-family: Poppins;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.7;
        margin-bottom: 10px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    /* Features Container */
    .featuresContainer {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    /* Feature Section Cards */
    .featureSection {
      background: rgba(255, 255, 255, 0.02);
      border: 1px solid rgba(255, 255, 255, 0.08);
      border-radius: 10px;
      overflow: hidden;
      transition: border-color 0.2s ease;
      scroll-margin-top: 20px;

      &:hover {
        border-color: rgba(255, 255, 255, 0.12);
      }

      .featureHeader {
        padding: 20px 24px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.05);
        display: flex;
        align-items: center;
        gap: 14px;
        background: rgba(255, 255, 255, 0.01);
      }

      .featureNumber {
        width: 36px;
        height: 36px;
        background: #007aff;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: Poppins;
        font-size: 14px;
        font-weight: 700;
        color: white;
        flex-shrink: 0;
      }

      .featureTitle {
        font-family: Poppins;
        font-size: 16px;
        font-weight: 600;
        color: white;
        margin: 0;
      }

      .featureBody {
        padding: 20px 24px;
      }

      .featureContent {
        .contentBlock {
          margin-bottom: 20px;

          &:last-child {
            margin-bottom: 0;
          }
        }

        .contentHeading {
          font-family: Poppins;
          font-size: 11px;
          font-weight: 600;
          color: #007aff;
          margin-bottom: 10px;
          text-transform: uppercase;
          letter-spacing: 0.08em;
        }

        .contentParagraph {
          color: #b8b8b8;
          font-family: Poppins;
          font-size: 13px;
          font-weight: 400;
          line-height: 1.6;
          margin-bottom: 6px;

          &:last-child {
            margin-bottom: 0;
          }
        }

        .stepsList {
          display: flex;
          flex-direction: column;
          gap: 8px;
          margin-top: 6px;
        }

        .stepParagraph {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          padding: 12px 14px;
          background: rgba(255, 255, 255, 0.02);
          border-radius: 6px;
          border-left: 2px solid #007aff;

          .stepNumber {
            width: 22px;
            height: 22px;
            background: rgba(0, 122, 255, 0.12);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: Poppins;
            font-size: 11px;
            font-weight: 600;
            color: #007aff;
            flex-shrink: 0;
          }

          .stepText {
            color: rgba(255, 255, 255, 0.85);
            font-family: Poppins;
            font-size: 13px;
            font-weight: 400;
            line-height: 1.6;
            flex: 1;
          }
        }
      }

      .videoContainer {
        margin-top: 20px;
        padding-top: 20px;
        border-top: 1px solid rgba(255, 255, 255, 0.05);
        display: flex;
        justify-content: center;
      }
    }

    /* Conclusion Section */
    .conclusionSection {
      margin-top: 32px;
      margin-bottom: 90px;
      padding: 28px;
      background: rgba(0, 122, 255, 0.06);
      border: 1px solid rgba(0, 122, 255, 0.15);
      border-radius: 10px;
      text-align: center;

      .conclusionTitle {
        font-family: Poppins;
        font-size: 18px;
        font-weight: 600;
        color: white;
        margin-bottom: 12px;
      }

      .contentParagraph {
        color: rgba(255, 255, 255, 0.75);
        font-family: Poppins;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.7;
        max-width: 600px;
        margin: 0 auto;
      }
    }
  }

  /* Video Container Styling */
  .guideVideoDiv {
    position: relative;
    width: 100%;
    max-width: 600px;
    aspect-ratio: 16 / 9;
    border-radius: 8px;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(255, 255, 255, 0.1);

    img {
      max-width: 100%;
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 8px;
    }

    video {
      max-width: 100%;
      width: 100%;
      height: 100%;
      object-fit: contain;
      border-radius: 8px;
    }

    .controlsDiv {
      width: 100%;
      height: 100%;
      top: 0px;
      left: 0px;
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      transition: background 0.2s ease;

      &:hover {
        background: rgba(0, 0, 0, 0.3);
      }

      .skipTimeButtons {
        background-color: transparent;
        background: transparent;
        color: white;
        font-size: 24px;
        border: none;
        height: 40px;
        width: 40px;
        margin: 0px 10px;
        cursor: pointer;
        transition: all 0.2s ease;
        opacity: 0;

        &:hover {
          color: #007aff;
          transform: scale(1.1);
        }
      }

      .playPauseBtn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 50px;
        height: 50px;
        aspect-ratio: 1;
        border-radius: 50%;
        border: none;
        background: rgba(0, 122, 255, 0.9);
        cursor: pointer;
        transition: all 0.2s ease;

        &:hover {
          background: #007aff;
          transform: scale(1.05);
        }

        svg {
          font-size: 20px;
          color: white;
        }
      }

      .fullScreenBtton {
        position: absolute;
        top: 12px;
        right: 12px;
        background: rgba(0, 0, 0, 0.6);
        border: none;
        border-radius: 6px;
        padding: 6px;
        cursor: pointer;
        transition: all 0.2s ease;
        opacity: 0;

        &:hover {
          background: rgba(0, 0, 0, 0.8);
        }
      }
    }

    .pauseBtn,
    .skipTimeButtons,
    .fullScreenBtton {
      opacity: 0;
      transition: opacity 0.2s ease;
    }

    &:hover {
      .pauseBtn,
      .skipTimeButtons,
      .fullScreenBtton {
        opacity: 1;
      }
    }
  }

  /* Responsive Design */
  @media (max-width: 768px) {
    .userGuideInner {
      .userGuideHead {
        padding: 20px;

        .userGuideTitle {
          font-size: 22px;
        }

        .userGuideSubtitle {
          font-size: 13px;
        }

        .searchWrapper {
          max-width: 100%;
        }
      }

      .tableOfContents {
        padding: 16px;

        .tocTitle {
          font-size: 10px;
          margin-bottom: 12px;
        }
      }

      .mainContent {
        padding: 20px 16px 50px;
      }

      .introSection {
        padding: 20px;
        margin-bottom: 24px;

        .introTitle {
          font-size: 16px;
        }

        .contentParagraph {
          font-size: 13px;
        }
      }

      .platformGuideSection {
        margin-bottom: 24px;

        .sectionTitle {
          font-size: 18px;
        }

        .contentParagraph {
          font-size: 13px;
        }
      }

      .featuresContainer {
        gap: 14px;
      }

      .featureSection {
        .featureHeader {
          padding: 16px 18px;
          gap: 12px;
        }

        .featureNumber {
          width: 32px;
          height: 32px;
          font-size: 13px;
        }

        .featureTitle {
          font-size: 14px;
        }

        .featureBody {
          padding: 16px 18px;
        }

        .featureContent {
          .contentHeading {
            font-size: 10px;
          }

          .contentParagraph {
            font-size: 12px;
          }

          .stepParagraph {
            padding: 10px 12px;
            gap: 10px;

            .stepNumber {
              width: 20px;
              height: 20px;
              font-size: 10px;
            }

            .stepText {
              font-size: 12px;
            }
          }
        }
      }

      .conclusionSection {
        padding: 20px;
        margin-top: 24px;

        .conclusionTitle {
          font-size: 16px;
        }

        .contentParagraph {
          font-size: 13px;
        }
      }
    }
  }

  @media (max-width: 480px) {
    .userGuideInner {
      .userGuideHead {
        padding: 16px;
        gap: 16px;

        .userGuideTitle {
          font-size: 20px;
        }
      }

      .mainContent {
        padding: 16px 12px 40px;
      }

      .introSection {
        padding: 16px;
      }

      .featureSection {
        .featureHeader {
          padding: 14px 16px;
        }

        .featureNumber {
          width: 28px;
          height: 28px;
          font-size: 12px;
          border-radius: 6px;
        }

        .featureTitle {
          font-size: 13px;
        }

        .featureBody {
          padding: 14px 16px;
        }
      }

      .conclusionSection {
        padding: 16px;
      }
    }
  }
`;
